import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export function SortableItem(props) {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id: props.id });

	const baseTransform = CSS.Transform.toString(transform);
	const style = {
		transform: isDragging
			? [baseTransform, "scale(1.075)"].filter(Boolean).join(" ")
			: baseTransform,
		transition,
		marginTop: isDragging ? "-5px" : 0,
		opacity: isDragging ? 0.5 : 1,
	};

	// Función para combinar refs - siempre se define pero solo se usa cuando es necesario
	const createCombinedRef = (childRef) => {
		return (node) => {
			setNodeRef(node);
			if (childRef) {
				if (typeof childRef === "function") {
					childRef(node);
				} else if (childRef) {
					childRef.current = node;
				}
			}
		};
	};

	// Si children es una función, pasarle los listeners y attributes
	if (typeof props.children === "function") {
		return (
			<div ref={setNodeRef} style={style}>
				{props.children({
					dragListeners: listeners,
					dragAttributes: attributes,
				})}
			</div>
		);
	}

	// Si no, comportamiento normal
	const childRef = props.children?.ref;
	const combinedRef = createCombinedRef(childRef);

	const childWithProps = React.cloneElement(props.children, {
		ref: combinedRef,
		sx: {
			...props.children.props.sx,
			...style,
		},
	});

	return childWithProps;
}
